export default "__VITE_ASSET__lzpu1WY7__"